/**
 * Created by Miguel on 23/05/2017
 */
import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation,  } from '@angular/core';
import {UserService} from "../../../services/user.service";
import { ActivatedRoute} from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import {Router} from "@angular/router";
import { AppDataService }  from '../../../services/app-data.service';
import { CompanyService }  from '../../../services/company.service';

declare var $ : any;
declare var Swal: any

@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'skills-modal',
    templateUrl:'skills-modal.html',
    providers  : [],  
})
export class SkillsModal implements OnInit {
  public list;
  public message;

    public ngOnInit() : any {
    }

    public clickItem(skill){
      Swal.fire({title:skill.name,
                      text:skill.description,
                      confirmButtonText:'Usar Talento',
                      cancelButtonText:'Cancelar',
                      showCloseButton: true,
                      showCancelButton: true,
                      focusConfirm: false, 
                      }).then((result) => {
                        if (result.dismiss=='backdrop') {}
                        else if (result.dismiss=='close') {}
                        else if (result.dismiss=='cancel'){
                        }
                        else{
                            this._appData.param={kind:'skill',skill:skill}
                            $('#skillsModal').modal('hide')
                            $('#craftMenuModal').modal('show')
                            $('#craftMenuModalClick').click()

  //                          this._companyService.openExternalLink(item.param.link,true);
                        }
                    });             

    }
    public updateSkills(){
      this._companyService.getUserSkillsRef(this._appData.instagramUser).set(this._appData.userEventSkills);

    }
    public change() {
      this.list=[]
      if (!this._appData.userEventSkills){
        this._companyService.getUserSkills();
      }
      else{
        this.list=[]
        for (let prop in this._appData.userEventSkills){
          this.list.push(this._appData.userEventSkills[prop])
        }
      }
    }
    constructor( public _appData : AppDataService,private _companyService : CompanyService,public _sanitizer: DomSanitizer,public _router : Router,private _routeParams : ActivatedRoute,private _auth : UserService) {
    }



}


// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/skills/skills-modal.ts